import { AsyncComponent } from '@frontend/elements';
import { lazy } from 'react';
import { Route } from 'react-router-dom';

const JobOverview = lazy(() => import('./job-overview'));
const JobCreate = lazy(() => import('./job-create/job-create.component'));
const JobDetail = lazy(() => import('./job-detail/job-detail.component'));
const JobUpdate = lazy(() => import('./job-update/job-update.component'));

export function JobRoutes() {
    return (
        <Route path='jobs'>
            <Route
                index
                element={
                    <AsyncComponent>
                        <JobOverview />
                    </AsyncComponent>
                }
            />
            <Route
                path='create'
                element={
                    <AsyncComponent>
                        <JobCreate />
                    </AsyncComponent>
                }
            />

            <Route path=':jobId'>
                <Route
                    path='update'
                    element={
                        <AsyncComponent>
                            <JobUpdate />
                        </AsyncComponent>
                    }
                />
                <Route
                    path='detail'
                    element={
                        <AsyncComponent>
                            <JobDetail />
                        </AsyncComponent>
                    }
                />
            </Route>
        </Route>
    );
}
